import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=8856c1be&scoped=true&"
import script from "./HeaderLogo.vue?vue&type=script&lang=ts&"
export * from "./HeaderLogo.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderLogo.vue?vue&type=style&index=0&id=8856c1be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8856c1be",
  null
  
)

export default component.exports